<template>
  <v-layout row fill-height>
    <v-flex
      v-if="$vuetify.breakpoint.mdAndUp || !$route.params.id"
      :md4="$route.params.id"
    >
      <v-card>
        <v-toolbar dense class="admin-list-toolbar">
          <v-tabs
            v-if="
              ($vuetify.breakpoint.mdAndUp && !$route.params.id)
              || ($vuetify.breakpoint.xl && $route.params.id)
            "
            :value="service"
            :key="service"
            color="transparent"
            slider-color="primary"
          >
            <v-tab
              v-for="ser in services"
              :key="ser"
              :tag="ser"
              :to="`/admin/${ser}`"
            >
              {{ser}}
            </v-tab>
          </v-tabs>
          <v-select
            v-else
            dense
            shrink
            :items="services"
            :value="service"
            @input="if(service !== $event) $router.push(`/admin/${$event}`)"
            class="text-capitalize"
          />
          <v-spacer />
          <v-text-field
            v-model.trim="search"
            append-icon="far fa-search"
            label="Search..."
            single-line
          />

          <v-tooltip top>
            <v-btn
              flat
              icon
              :to="`/admin/${service}/new`"
              slot="activator"
            >
              <v-icon>fal fa-plus</v-icon>
            </v-btn>
            <span class="text-capitalize">Add {{service}}</span>
          </v-tooltip>
        </v-toolbar>
        <admin-list
          :service="service"
          :search="search"
        />
      </v-card>
    </v-flex>
    <v-flex
      xs12
      md8
      v-if="$route.params.id"
    >
      <admin-edit :service="service"/>
    </v-flex>
  </v-layout>
</template>

<script>
import adminEdit from './partials/admin/edit.vue';
import adminList from './partials/admin/list.vue';

export default {
  components: {
    adminEdit,
    adminList,
  },
  data() {
    return {
      services: [
        'flags',
        'locations',
        'procedures',
        'steps',
        'units',
        'users',
      ],
      search: '',
    };
  },
  computed: {
    service() {
      return this.services.indexOf(this.$route.params.service) !== -1
        ? this.$route.params.service
        : 'users';
    },
  },
  mounted() {
    // this.services.reverse().forEach((s) => { this.$store.dispatch(`${s}/find`); });
  },
};
</script>

<style lang="stylus" scoped>
.admin-list-toolbar >>> .v-select
  width min-content
</style>
